import type { ChangeRequestStatus } from '../../types';
import type { StatusChipColor } from '../../theme';

export interface ChangeRequestStatusMeta {
  label: string;
  color: StatusChipColor;
}

/** Nhãn + màu tiếng Việt cho từng trạng thái xử lý Change Request. */
export const CHANGE_REQUEST_STATUS_META: Record<ChangeRequestStatus, ChangeRequestStatusMeta> = {
  OPEN: { label: 'Đang mở', color: 'warning' },
  IN_PROGRESS: { label: 'Đang xử lý', color: 'info' },
  RESOLVED: { label: 'Đã xử lý', color: 'success' },
  REJECTED: { label: 'Từ chối', color: 'error' },
};
